import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateSupplierGroupSettings } from '../../../../common/api/clients/company.api';
import { queries } from '../../../../common/api/queryKeys/queries';

export const useSupplierGroupSettingsUpdate = (supplierGroupId: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateSupplierGroupSettings,
        onSuccess: () => {
            return queryClient.invalidateQueries({
                queryKey: queries.supplierGroups.detail(supplierGroupId)._ctx.settings.queryKey,
            });
        },
    });
};
